export { default } from './PartnersSection';
